import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface StatCardProps {
  label: string;
  value: string | React.ReactNode;
  variant?: 'default' | 'destructive' | 'warning' | 'success' | 'info';
  icon?: LucideIcon;
  iconColor?: string;
  className?: string;
  isLoading?: boolean;
}

export function StatCard({
  label,
  value,
  variant = 'default',
  icon: Icon,
  iconColor,
  className,
  isLoading = false
}: StatCardProps) {
  const valueClassName = cn('text-2xl font-semibold', {
    'text-destructive': variant === 'destructive',
    'text-orange-600': variant === 'warning',
    'text-green-600': variant === 'success',
    'text-blue-600': variant === 'info'
  });

  if (isLoading) {
    return (
      <Card className={cn('p-4', className)}>
        <div className="flex items-center justify-between">
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-[100px]" />
            <Skeleton className="h-7 w-[150px]" />
          </div>
          {Icon && <Skeleton className="h-8 w-8 rounded" />}
        </div>
      </Card>
    );
  }

  return (
    <Card className={cn('p-4', className)}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="text-sm text-muted-foreground">{label}</div>
          <div className={valueClassName}>{value}</div>
        </div>
        {Icon && <Icon className={cn('w-8 h-8', iconColor || 'text-muted-foreground')} />}
      </div>
    </Card>
  );
}
